import React, { useEffect, useState } from "react";
import extractMapCoordinates from "../../utils/extractMapCoordinates";
import MapContainer from "../shared/map-container";

const GoogleMapComponent = ({ locationDetails }) => {
	const [mapLocation, setMapLocation] = useState({ lat: 0, lng: 0 });

	useEffect(() => {
		if (!locationDetails) return;

		if (locationDetails?.lat && locationDetails?.lng) {
			setMapLocation({ lat: locationDetails.lat, lng: locationDetails.lng });
		} else if (locationDetails?.mapLink && locationDetails.mapLink !== "") {
			const coords = extractMapCoordinates(locationDetails.mapLink);
			if (coords) {
				setMapLocation(coords);
			}
		} else if (
			locationDetails?.city &&
			locationDetails?.area &&
			locationDetails?.country &&
			typeof window !== "undefined" &&
			window.google?.maps?.Geocoder
		) {
			const address = `${locationDetails.city}, ${locationDetails.area}, ${locationDetails.country}`;
			const geocoder = new window.google.maps.Geocoder();
			geocoder.geocode({ address }, (results, status) => {
				if (status === "OK" && results[0]) {
					const loc = results[0].geometry.location;
					setMapLocation({ lat: loc.lat(), lng: loc.lng() });
				}
			});
		}
	}, [locationDetails]);

	return (
		<div className="py-5 lg:w-3/4 w-full px-5 border-t mx-auto">
			<h2 className="text-2xl font-bold mb-4">Where We Are Located</h2>
			<MapContainer
				lat={mapLocation.lat}
				lng={mapLocation.lng}
				draggable={false}
				onLocationChange={() => {}}
			/>
		</div>
	);
};

export default GoogleMapComponent;
